import { SugarModel } from "../../loader/SugarModel";
import { SugarModelConfigurator } from "../../loader/SugarModelConfigurator";

export function uniqueSugarModels(
  models: readonly unknown[],
  include: (model: SugarModel) => boolean = () => true,
): SugarModel[] {
  const seen = new Set<string>();
  return models.filter((model): model is SugarModel => {
    if (!(model instanceof SugarModel) || !include(model)) return false;
    const key = model.uuid ?? String(model.id);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function collectConfiguratorLeafModels(
  configurator: SugarModelConfigurator,
  include: (model: SugarModel) => boolean = () => true,
): SugarModel[] {
  const leaves: SugarModel[] = [];
  const visit = (model: unknown): void => {
    if (!(model instanceof SugarModel)) return;
    if (model instanceof SugarModelConfigurator) {
      model.products.flat().forEach(visit);
      return;
    }
    leaves.push(model);
  };

  configurator.products.flat().forEach(visit);
  return uniqueSugarModels(leaves, include);
}
